import { colors } from '@EVOCORP/corechat-theme';
import { alpha, Box, makeStyles, Typography } from '@material-ui/core';

import MessageBase, { MessageBaseProps } from './MessageBase';
import { ReactComponent as ChatErrorIcon } from '../assets/images/chat-error-icon.svg';

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(1),
  },
  roundedBackground: {
    height: spacing(4),
    width: spacing(4),
    borderRadius: spacing(2),
    backgroundColor: palette.text.disabled,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  message: ({ autor }: MessageBaseProps) => {
    const color = autor
      ? palette.getContrastText(colors.light.primary.dark)
      : palette.getContrastText(palette.text.disabled);

    return {
      color: alpha(color, 0.75),
      fontStyle: 'italic',
    };
  },
}));

type FallbackMessageProps = MessageBaseProps;

export default function FallbackMessage(props: FallbackMessageProps) {
  const classes = useStyles(props);

  return (
    <MessageBase {...props} maxWidth="40%">
      <Box className={classes.root}>
        <Box className={classes.roundedBackground}>
          <ChatErrorIcon width={16} />
        </Box>
        <Typography variant="body2" className={classes.message}>
          Esse tipo de mensagem ainda não é compatível com o Tarelo e não pôde
          ser exibida.
        </Typography>
      </Box>
    </MessageBase>
  );
}
